import { ThemeProvider } from 'styled-components';
import { EnumFilterTheme } from '../../../../../tools/typings/styled-components';
import { EnumFilterProps, EnumFilter } from '../EnumFilter';

export const DropDownEnumFilter = <T,>(props: EnumFilterProps<T>) => (
  <ThemeProvider theme={parentTheme => ({ ...parentTheme, enumFilter: DropDownEnumFilterTheme })}>
    <EnumFilter {...props} />
  </ThemeProvider>
);

const DropDownEnumFilterTheme: EnumFilterTheme = {
  titleMargin: '0 32px 0',
  captionMargin: '8px 32px 0',
  optionGroupMargin: '16px 0 0',
  optionPadding: '16px 32px',
  titleFontSize: '24px',
};
